<ul class="navigation" [ngClass]="viewportClass">
  @if (isLoggedIn) {
    <li class="navigation--item"><a class="navigation--link" routerLinkActive="active" routerLink="/dashboard">DASHBOARD</a></li>
  }
  @if (isLoggedIn) {
    <li class="navigation--item"><a class="navigation--link" routerLinkActive="active" routerLink="/accounts">ACCOUNTS</a></li>
  }
  @if (isLoggedIn) {
    <li class="navigation--item"><a class="navigation--link" routerLinkActive="active" routerLink="/agreements">AGREEMENTS</a></li>
  }
  @if (isLoggedIn) {
    <li class="navigation--item"><a class="navigation--link" routerLinkActive="active" routerLink="/users/profile">PROFILE</a></li>
  }
  @if (!isLoggedIn) {
    <li class="navigation--item"><a class="navigation--link" routerLinkActive="active" href="/#features">FEATURES</a></li>
  }
  @if (!isLoggedIn) {
    <li class="navigation--item"><a class="navigation--link" routerLinkActive="active" href="/#about">ABOUT US</a></li>
  }
  @if (!isLoggedIn) {
    <li class="navigation--item"><a class="navigation--link" routerLinkActive="active" href="/#pricing">PRICING</a></li>
  }
  @if (!isLoggedIn) {
    <li class="navigation--item"><a class="navigation--link" routerLinkActive="active" href="/#contact">CONTACT US</a></li>
  }
  @if (!isLoggedIn) {
    <li class="navigation--item"><a class="navigation--link" routerLinkActive="active" routerLink="/users/login">LOGIN</a></li>
  }
  @if (!isLoggedIn) {
    <li class="navigation--item"><a class="navigation--link" routerLinkActive="active" routerLink="/users/register">SIGN UP</a></li>
  }
</ul>